<template>
  <span class="kb-pill">{{ value }}</span>
</template>

<script>
export default {
  props: {
    value: Number,
    defaultWidth: String,
  },
};
</script>

<style lang="scss" scoped="">
.kb-pill {
  display: inline-block;
  margin-left: 5px;
  background-color: #00d1b2;
  border-radius: 10px;
  color: black;
  min-width: 20px;
  text-align: center;
  font-size: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 4px;
  padding-right: 4px;
}
</style>
